import React from "react";
import PropTypes from "prop-types";

function ContentSection({ children, title }) {
  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{title}</div>
      {children}
    </div>
  );
}

ContentSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ContentSection;
